module.exports = __webpack_public_path__ + "img/GH-kyujin-top-back002.f73a7cad.webp";